import { render, staticRenderFns } from "./VideoLayout.vue?vue&type=template&id=7e31fa7c&scoped=true"
import script from "./VideoLayout.vue?vue&type=script&lang=js"
export * from "./VideoLayout.vue?vue&type=script&lang=js"
import style0 from "./VideoLayout.vue?vue&type=style&index=0&id=7e31fa7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e31fa7c",
  null
  
)

export default component.exports